









import { Component, Prop, Vue } from 'vue-property-decorator';
import { isExternal } from '@tencent/s2-client-vue-lib';

@Component({
	name: 'SidebarItemLink'
})
/** docs */
export default class extends Vue {
	@Prop({ required: true }) private to!: string;

	/** document hooks */
	private isExternal: any = isExternal;
}
